import React from "react";
import {Helmet} from "react-helmet-async";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {Container} from "react-bootstrap";
import GmTableHandler from "../../components/projecten/GmTableHandler";

const GMPage = () => (
    <React.Fragment>
        <Helmet title="GM"/>
        <Container fluid className="p-0">
            <GmTableHandler/>
        </Container>
    </React.Fragment>
);

export default GMPage;
